module.exports = __webpack_public_path__ + "static/media/layout.802edbb5.svg";